import { isSemiosEmployeeOrTester } from 'utils/isSemiosEmployeeOrTester'

export const generatePropertyLabel = (o: { propertyName: string; propertyId: number }) => {
  return isSemiosEmployeeOrTester() ? `${o.propertyName} (${o.propertyId})` : o.propertyName
}
